<mat-toolbar>
    <button mat-icon-button aria-label="Menu" [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <a id="home" [routerLink]="['/']">
            <button mat-menu-item color="primary">
                <mat-icon>home</mat-icon>
                Home
            </button>
        </a>
        @if (showInterventionTracker && loginDisplay) {
        <a id="report-interventions" [routerLink]="['/intervention-tracker']">
            <button mat-menu-item color="primary">
                <mat-icon>description</mat-icon>
                Report Interventions
            </button>
        </a>
        @if(showAnalytics){
        <a id="intervention-analytics" [routerLink]="['/intervention-analytics']">
            <button mat-menu-item color="primary">
                <mat-icon>analytics</mat-icon>
                Intervention Analytics
            </button>
        </a>
        }
        <a id="help" [routerLink]="['/help']">
            <button mat-menu-item color="primary">
                <mat-icon>help</mat-icon>
                Help
            </button>
        </a>
        }

        @if (!loginDisplay) {
        <button mat-menu-item color="primary" (click)="loginRedirect()">
            <mat-icon>login</mat-icon>
            Login
        </button>
        }
        @if (loginDisplay) {
        <button id="logout" mat-menu-item color="primary" (click)="logout()">
            <mat-icon>logout</mat-icon>
            Logout
        </button>
        }

    </mat-menu>
</mat-toolbar>

<main>
    @if (!loginDisplay) {
    <div class="login-container">
        <button id="login" mat-fab extended color="primary" (click)="loginRedirect()">
            <mat-icon>login</mat-icon>
            Login
        </button>
    </div>

    }
    @if (!isIframe && loginDisplay) {
    @if (showInterventionTracker) {
    <router-outlet id="router" class="router-flex"></router-outlet>
    }
    @else {
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
        <h1 id="not-authorized-message">You are not authorized to use the application</h1>
        <br />
        <h2>Please contact jorgen.haaland&#64;wheel.me if access is required</h2>
    </div>
    }
    }
</main>
<footer class="footer">
    <p>&copy; Wheel.me AS All Rights Reserved, Version {{ version }}</p>
</footer>
